'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var OnlineBookingAppIcon = function OnlineBookingAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    viewBox: "0 0 500 500",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }), React__default["default"].createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React__default["default"].createElement("g", {
    id: "Online-Booking-2"
  }, React__default["default"].createElement("circle", {
    id: "Oval-4",
    fill: "#42A5F5",
    cx: "250",
    cy: "250",
    r: "206"
  }), React__default["default"].createElement("path", {
    d: "M250,456 C363.770658,456 456,363.770658 456,250 C456,136.229342 363.770658,44 250,44 L250,456 Z",
    id: "Oval-4-Copy-3",
    fill: "#1976D2"
  }), React__default["default"].createElement("ellipse", {
    id: "Oval-4-Copy",
    fill: "#2196F3",
    cx: "250",
    cy: "250",
    rx: "125",
    ry: "206"
  }), React__default["default"].createElement("path", {
    d: "M250,456 C319.035594,456 375,363.770658 375,250 C375,136.229342 319.035594,44 250,44 L250,456 Z",
    id: "Oval-4-Copy-4",
    fill: "#1E88E5"
  }), React__default["default"].createElement("path", {
    d: "M250,456 C363.770658,456 456,363.770658 456,250 L44,250 C44,363.770658 136.229342,456 250,456 Z",
    id: "Oval-4-Copy-5",
    fillOpacity: "0.1",
    fill: "#000000",
    style: {
      mixBlendMode: 'overlay'
    }
  }), React__default["default"].createElement("g", {
    id: "Group",
    transform: "translate(449.570200, 330.179584) rotate(-37.000000) translate(-449.570200, -330.179584) translate(408.570200, 260.679584)"
  }, React__default["default"].createElement("path", {
    d: "M40.8410646,80.881324 L40.8410646,138.561538",
    id: "Line-2",
    stroke: "#E0E0E0",
    strokeWidth: "9",
    strokeLinecap: "square"
  }), React__default["default"].createElement("polygon", {
    id: "Shape",
    fill: "#E0E0E0",
    fillRule: "nonzero",
    points: "40.8410646 0 0 99.5977429 3.86628745 103.46403 40.8410646 87.1276045 77.8158418 103.46403 81.6821292 99.5977429"
  })))));
};

var OnlineBookingAppIcon$1 = iconStyles()(OnlineBookingAppIcon);

module.exports = OnlineBookingAppIcon$1;
